// extracted by mini-css-extract-plugin
export const page = "blog-module--page--2L8sw";
export const text = "blog-module--text--31oE6";